var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasExtencion('resumen_caja'))?_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('resumen-caja'),expression:"'resumen-caja'"}],staticClass:"m-l-15",attrs:{"variant":"primary"}},[_vm._v(" Resumenes ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }